export var SELECT_ALL_VALUE = "selectAll";
export var NONE_VALUE = "none";
export var OTHER_VALUE = "other";
